module.exports = __webpack_public_path__ + "img/csr_swiper_04_10.002385cc.jpg";